import _objectSpread from "__________________________________________/i18n_fe/i18n_ecommerce_alliance/node_modules/.pnpm/@babel+runtime@7.27.0/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { createModel } from '@rematch/core';
import { InvitationGroupStatus } from '@/api/affiliate/serv/oec_affiliate_invitation_api';
import { INIT_SEARCH_PARAMS } from '@/pages/find-creators/target-invitation/constants/invitation-list';
var initialState = {
  searchParams: INIT_SEARCH_PARAMS,
  activeTab: InvitationGroupStatus.INVITATION_GROUP_STATUS_LIVE,
  isloadOptResultFromCache: false,
  creatorUserName: ''
};
export var invitationListModel = createModel()({
  state: initialState,
  reducers: {
    saveState: function saveState(state, payload) {
      return _objectSpread(_objectSpread({}, state), payload);
    },
    clearState: function clearState() {
      return _objectSpread({}, initialState);
    },
    notUseCacheState: function notUseCacheState(state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        isloadOptResultFromCache: false
      });
    }
  }
});